import { CommonTouchBase, TouchData } from '../data';
import { ZEDCamera } from '../ZEDCamera';
import { moveByPanning } from '../ZEDCameraInputHelper';
import { InputCanvasProps } from '../ZEDCameraInputManager';
import { Tools } from '@babylonjs/core';

export const SingleTouchPanning: CommonTouchBase = {
  type: 'CommonTouch',
  touchCount: 1,
  key: 'SingleTouchPanning',
  name: 'SingleTouchPanning',
  option: {
    mouseButton: 'left',
    mouseKeyCode: 'none',
  },
  attachControl(
    _camera: ZEDCamera,
    _canvasProps: InputCanvasProps,
    _isMobileOrTablet: boolean,
    _noPreventDefault?: boolean | undefined
  ) {},
  detachControl(_camera: ZEDCamera, _isMobileOrTablet: boolean) {},
  checkInputs(_camera: ZEDCamera) {},
  reset() {},
  onMousedown(camera: ZEDCamera, _touchData: TouchData, _canvasProps: InputCanvasProps) {
    camera.stopPlayingAnimation();
  },
  onMousemove(camera: ZEDCamera, touchData: TouchData, canvasProps: InputCanvasProps) {
    if (camera.beta < Tools.ToRadians(60)) {
      camera.xAxisPanningLock = false;
      camera.yAxisPanningLock = true;
      camera.zAxisPanningLock = false;
    } else {
      camera.xAxisPanningLock = false;
      camera.yAxisPanningLock = false;
      camera.zAxisPanningLock = false;
    }
    moveByPanning(camera, touchData.movement, canvasProps);
  },
  onMouseup(_camera, _touchData, _canvasProps) {},
  onTouchStart(camera, _touchData, _canvasProps) {
    camera.stopPlayingAnimation();
  },
  onTouchMoved(camera, touchData, canvasProps) {
    if (touchData[0]) moveByPanning(camera, touchData[0].movement, canvasProps);
  },
  onTouchEnd(_camera: ZEDCamera, _touchData: TouchData[], _canvasProps: InputCanvasProps) {},
};
